import React from 'react'
import { debounce } from 'lodash/function'

export default class DemoCompaniesTable extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            demoCompanies: [],
            total: 0,
            isSuperUser: false,
            loading: false,
            showUserCompanies: false,
            showEnabledOnly: false,
            sortDirection: 'desc',
            sortColumn: 'tellmyco.updated_at',
            searchQuery: '',
            currentPage: 1
        }
    }

    componentDidMount () {
        this.fetchDemoCompanies()
    }

    fetchDemoCompanies () {
        this.setState({loading: true})

        let url = '/demo-companies.json'
        url += `?sort_col=${this.state.sortColumn}&sort_dir=${this.state.sortDirection}&search=${encodeURI(this.state.searchQuery)}&show_user_companies=${this.state.showUserCompanies}&show_enabled_only=${this.state.showEnabledOnly}&page=${this.state.currentPage}`
        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
        })
            .then(response => response.json())
            .then(data => {
                this.setState({ demoCompanies: data.demoCompanies, isSuperUser: data.isSuperUser, total: data.total })
            })
            .catch(error => {
                console.error('Error fetching data:', error)
            })
            .finally(() => {
                this.setState({loading: false})
            })
    }

    sortBy = (column) => {
        const isAscending = this.state.sortDirection === 'asc'
        this.setState({ sortDirection: isAscending ? 'desc' : 'asc', sortColumn: column }, this.fetchDemoCompanies)
    }

    handlePageChange = (pageNumber) => {
        this.setState({ currentPage: pageNumber }, this.fetchDemoCompanies);
    }

    render () {
        const { currentPage } = this.state;

        const totalPages = Math.ceil(this.state.total / 15) || 1;
        const handleSearchChange = (event) => {
            const query = event.target.value;
            this.setState({ searchQuery: query }, debounce(this.fetchDemoCompanies, 500))
        }
        const handleShowUserCompanies = (event) => {
            this.setState({ showUserCompanies: event.target.checked }, this.fetchDemoCompanies)
        }
        const handleShowEnabledOnly = (event) => {
            this.setState({ showEnabledOnly: event.target.checked }, this.fetchDemoCompanies)
        }

        return (
            <div className="row">
                <div className="d-flex w-100 demo-companies-wrapper container-fluid">
                    <div className="input-group feedback-form-control border col-md-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text"><i className="fas fa-search"></i></span>
                        </div>
                        <input type="search" className="form-control pl-1 label"
                               value={this.state.searchQuery}
                               onChange={handleSearchChange}
                               placeholder={ __('Search') }/>
                    </div>
                    <div className="d-flex demo-companies-anchors">
                        <label htmlFor="mineOnly"
                               className="align-items-center mb-0 btn btn-outline-primary mineonly">
                            <input type="checkbox" className="mr-2"
                                   checked={this.state.showUserCompanies}
                                   onChange={handleShowUserCompanies}
                                   id="mineOnly"/> {__('Show My Demo Accounts Only')}:
                        </label>
                        {this.state.isSuperUser &&
                            <label htmlFor="enabledOnly"
                                   className="align-items-center mb-0 btn btn-outline-primary enabledonly">
                                <input type="checkbox" className="mr-2"
                                       checked={this.state.showEnabledOnly}
                                       onChange={handleShowEnabledOnly}
                                       id="enabledOnly"/> {__('Show Enabled Accounts Only')}:
                            </label>
                        }
                    </div>
                </div>

                <div className="col-md-12 overflow-x-scroll mx-0 px-0">
                    <div className={`loader text-center mb-3 mt-2 demo-accounts ${this.state.loading ? '' : 'd-none'}`}
                         style={{alignItems: 'start !important'}}>
                        <div className="badge badge-pill badge-secondary mt-4"
                             style={{height: 'fit-content !important'}}>
                            <img src="/img/spinner.png" className="spinner anim-spin mb-0 mr-2"
                                 style={{height: '20px !important'}}/>
                            <span style={{fontSize: 'small'}}>{__('Loading')}...</span>
                        </div>
                    </div>

                    <table id="distributortable" className="table table-bordered demo-companies-table">
                        <thead>
                        <tr>
                            <th>
                                <div className="d-flex" onClick={() => this.sortBy('tellmyco.name')}
                                     data-sort={this.state.sortDirection}
                                     data-issorted={this.state.sortColumn === 'tellmyco.name'}>
                                    {__('Name')} <SortIcon/>
                                </div>
                            </th>
                            <th>{__('Branded Link')}</th>
                            <th>{__('Notes')}</th>
                            <th>
                                <div className="d-flex" onClick={() => this.sortBy('feedbacks_count')}
                                     data-sort={this.state.sortDirection}
                                     data-issorted={this.state.sortColumn === 'feedbacks_count'}>
                                    {__('FB Sent')} <SortIcon/>
                                </div>
                            </th>
                            <th>
                                <div className="d-flex" onClick={() => this.sortBy('user.firstname')}
                                     data-sort={this.state.sortDirection}
                                     data-issorted={this.state.sortColumn === 'user.firstname'}>
                                    {__('Distributor')} <SortIcon/>
                                </div>
                            </th>
                            <th>{__('Contacts')}</th>
                            <th>
                                <div className="d-flex" onClick={() => this.sortBy('tellmyco.updated_at')}
                                     data-sort={this.state.sortDirection}
                                     data-issorted={this.state.sortColumn === 'tellmyco.updated_at'}>
                                    {__('Last edited on')} <SortIcon/>
                                </div>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.state.demoCompanies.map((company) => {
                            return (
                                <tr className={company.is_disabled && 'is-disabled'} key={company.id}>
                                    <td>
                                        {
                                            this.state.isSuperUser || company.is_own ?
                                                <a href={`/demo-company/${company.id}`}
                                                   className="text-dark">{company.name}</a> :
                                                company.name
                                        }
                                    </td>
                                    <td>
                                        <a href={company.full_url} className="text-dark" target="_blank">
                                            {company.url}
                                        </a>
                                    </td>
                                    <td>
                                        {company.notes.length > 0 && (this.state.isSuperUser || company.is_own) &&
                                            <span data-toggle="tooltip" title={company.notes_tooltip}>
                                                <i className="fas fa-comment-alt"></i>
                                                {company.notes.length}
                                            </span>
                                        }
                                        {this.state.isSuperUser && company.google_place_id && company.google_place_id.length > 0 &&
                                            <span className="fa-stack">
                                                <i className="fab fa-google fa-stack-1x"></i>
                                                <i className="fas fa-ban fa-stack-2x" style={{ color: 'Tomato' }}></i>
                                            </span>
                                        }
                                    </td>
                                    <td>
                                        <a href={`/tellmyco/${company.id}/feedbacks?timeframe=lifetime&status=All`}
                                           className="text-dark">{company.feedbacks_count}</a>
                                    </td>
                                    <td>
                                        {this.state.isSuperUser && company.user &&
                                            <a href={`/view-as-user/login/${company.user.user_id}`}>
                                                {company.user_name}
                                            </a>
                                        }
                                        {this.state.isSuperUser && !company.user && __('Unknown')}
                                        {!this.state.isSuperUser && (company.user ? company.user_name : __('Unknown'))}
                                    </td>
                                    <td>
                                        {company.demo_company_emails.map((e, index) => {
                                            return (
                                                <div key={index}>
                                                    <p className="mb-0"><b>{e.email}</b></p>
                                                    {e.phone && e.phone.length > 0 &&
                                                        <small className="d-block">{e.phone}</small>}
                                                    <small
                                                        className="mb-2 d-block mb-2">{`${e.first_name} ${e.last_name}`}</small>
                                                </div>
                                            )
                                        })}
                                    </td>
                                    <td>
                                        {company.formatted_updated_at}
                                    </td>
                                </tr>
                            )
                        })}
                        </tbody>
                    </table>
                    <div className="d-flex flex-row justify-content-center align-items-center demo-companies-pagination">
                        {/* Pagination */}
                        <div className="d-flex flex-row mr-3 pagination">
                            <span>{ __('Pagination') }:</span>
                            {currentPage !== 1 &&
                                <>
                                    {/* "First" button */}
                                    <button onClick={() => this.handlePageChange(1)}>
                                        { __('First') }
                                    </button>


                                    {/* "Prev" button */}
                                    <button onClick={() => this.handlePageChange(currentPage - 1)}>
                                        &#8592;
                                    </button>
                                </>
                            }


                            {/* Pagination numbers */}
                            {totalPages > 5 && currentPage > 3 && (
                                <button
                                    onClick={() => this.handlePageChange(1)}
                                    className={currentPage === 1 ? 'active' : ''}
                                >
                                    1
                                </button>
                            )}
                            {totalPages > 5 && currentPage > 4 && <span>...</span>}

                            {Array.from({ length: totalPages }, (_, index) => {
                                const page = index + 1;
                                if (page >= currentPage - 2 && page <= currentPage + 2) {
                                    return (
                                        <button
                                            key={index}
                                            onClick={() => this.handlePageChange(page)}
                                            className={currentPage === page ? 'active' : ''}
                                        >
                                            {page}
                                        </button>
                                    );
                                }
                                return null;
                            })}

                            {totalPages > 5 && currentPage < totalPages - 3 && <span>...</span>}
                            {totalPages > 5 && currentPage < totalPages - 2 && (
                                <button
                                    onClick={() => this.handlePageChange(totalPages)}
                                    className={currentPage === totalPages ? 'active' : ''}
                                >
                                    {totalPages}
                                </button>
                            )}

                            {/* Next button */}
                            {currentPage !== totalPages &&
                                <>
                                    {/* "Next" button */}
                                    <button onClick={() => this.handlePageChange(currentPage + 1)}>
                                        &#8594;
                                    </button>

                                    {/* "Last" button */}
                                    <button onClick={() => this.handlePageChange(totalPages)}>
                                        { __('Last') }
                                    </button>
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const SortIcon = () => {
    return (
        <span className="table-header-sort-icons">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path
                d="M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z"/></svg>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path
                d="M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"/></svg>
        </span>
    )
}
